/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Spin,
  message,
  Carousel,
  Tooltip,
  Modal,
  Card,
} from "antd";

import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";

import "./index.scss";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import client_edit from "../../assests/images/clientedit.png";

import { dashboardMenuList } from "../../config/dashboard";
import DashbordCard from "./DashbordCard";
import constant from "../../constants/constants";
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import API from "../../api";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import nodeURLs from "../../api/nodeUrls";
import { capitalize } from "../../utils";
import urls from "../../api/urls";
import useCustomNavigate from "../../components/customNavigationHook";
import { useLock } from "../../store/LockContext";
import { Widget } from "lock-widget";
const { ROLES } = constant;
const { CP_ADMIN, CP_OPERATOR } = ROLES;

const { SHIPMENT_COUNT } = nodeURLs;

let getAllPincodes = JSON.parse(localStorage.getItem("allPincodes")) || null;
const currentEnv = process.env.REACT_APP_ENV;

function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();

  const [form] = Form.useForm();

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [onClickTime, setOnClickTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);
  const [userinfo] = useState(JSON.parse(localStorage.getItem("userinfo")));

  const [companyId] = useState(
    JSON.parse(localStorage.getItem("selectedCompany"))
  );

  const { isLocked, fetchLockStatus, lockRules } = useLock();

  const getRole = userinfo?.roles[0]?.replace(/.*_/, "");

  const styleObj = {
    inscanned: {
      styles: {
        backgroundColor: "#FFD3D1",
        border: "1px solid #FFD5D3",
      },
      textColor: { color: "#E65B6B" },
    },
    outscan: {
      styles: {
        backgroundColor: "#27AE6014",
        border: "1px solid #8CE7B3",
      },
      textColor: { color: "#107A59" },
    },
    expected: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
    pending: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColor: { color: "#c59f0c" },
    },
    defalut: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
  };

  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode)
      );
    }
  }, [getpremiseResponse]);

  useEffect(() => {
    navigate("/dashboard", { state: { test: "test" } });

    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
    fetchDeliveryPartners();
  }, []);

  const fetchDeliveryPartners = async () => {
    try {
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      const result = await API.Api(
        `${urls.DELIVERY_PARTNER_LIST}?email=${userinfo.username}`
      ).get();
      if (result?.response?.data) {
        sessionStorage.setItem(
          "deliveryPartner",
          JSON.stringify(result.response.data)
        );
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Failed to fetch delivery partner details"
      );
    }
  };

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (date = null) => {
    setLoading(true);
    const param = {
      date,
    };

    const response = await API.Api(`${SHIPMENT_COUNT}`).NodeGetWithPremise(
      date && param
    );

    if (response?.status) {
      setLoading(false);
      let data = response?.response?.data;
      // const { total_count: inscannedCount } = data.find(
      //   (item) => item.status === "inscanned"
      // );
      // const { total_count: outscanCount } = data.find(
      //   (item) => item.status === "outscan"
      // );

      // const pendingCount = Math.max(
      //   0,
      //   parseInt(inscannedCount, 10) - parseInt(outscanCount, 10)
      // );

      // data.push({
      //   status: "pending",
      //   total_count: String(pendingCount),
      // });
      const order = ["expected", "inscanned", "outscan", "pending"];
      data?.sort(
        (a, b) => order?.indexOf(a?.status) - order?.indexOf(b?.status)
      );
      setOnClickTime(moment().format("hh:mm a"));
      setTodayData(data);
    } else {
      setLoading(false);
      setTodayData([]);

      message.error(response?.statusText || "Internal server error");
    }

    setLoading(false);
  };

  // @ For Pincodes suggesstion
  const getAllPincodesForSuggestions = async () => {
    setLoading(true);
    let res = await API.Api(
      "https://bookingapis.innofulfill.com/pincode"
    ).get();
    if (res?.status) {
      setLoading(false);
      const response = res?.response?.data;
      localStorage.setItem(
        "allPincodes",
        JSON.stringify(
          response?.map((item) => ({
            Pincode: item.Pincode,
            StateName: item.StateName,
            CityName: item.CityName,
          }))
        ) || null
      );
    } else {
      setLoading(false);
      localStorage.setItem("allPincodes", null);

      message.error("Pincodes fetch error");
    }
  };

  useEffect(() => {
    if (getAllPincodes == null) {
      getAllPincodesForSuggestions();
    }
  }, [getAllPincodes]);

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleAfterChange = (current) => {
    setDay(current);
    if (current) {
      getTodaysData();
    } else {
      getTodaysData(moment().subtract(1, "days").format("YYYY-MM-DD"));
    }
  };

  const [open, setOpen] = useState(false);

  const role = JSON.parse(localStorage.getItem("userinfo"))?.roles;

  useEffect(() => {
    let role = JSON.parse(localStorage.getItem("userinfo"))?.roles;
    const showModal = localStorage.getItem("showClientEditModal");
    if (
      (role?.includes(CP_ADMIN) || role?.includes(CP_OPERATOR)) &&
      moment().isBefore("2025-05-24T23:59:59") &&
      (!showModal || showModal === "true")
    ) {
      setOpen(true);
    }
  }, []);

  const handleOk = (link) => {
    localStorage.setItem("showClientEditModal", "false");
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    localStorage.setItem("showClientEditModal", "false");
  };

  return (
    <div className="dashboard-container">
      <Modal
        open={open}
        centered
        onOk={() => {
          handleOk();
        }}
        onCancel={handleCancel}
        width={850}
      >
        <Carousel style={{ width: "100%" }} autoplay>
          <div className="p-05">
            <p
              className="fw-500 center"
              style={{ color: "#0cdf45", fontSize: "28px" }}
            >
              We’ve enabled the option to update client information in your
              account.
            </p>
            <div className="center">
              <img src={client_edit} style={{ height: "25%", width: "90%" }} />
            </div>

            <p className="mt-1" style={{ fontSize: "18px" }}>
              Navigate to{" "}
              <span className="fw-500">
                Profile → Client List → Client Detail → Edit, or{" "}
                <a
                  onClick={() => {
                    navigate("/profile", { state: { tab: "4" } });
                    localStorage.setItem("showClientEditModal", "false");
                  }}
                >
                  click here{" "}
                </a>
              </span>
              to go directly to the client listing.
            </p>
          </div>
        </Carousel>
      </Modal>

      <Spin spinning={fetching || loading}>
        <Form form={form} layout="vertical" autoComplete="off">
          {role?.includes(CP_ADMIN) && (
            <Card className="cardLock">
              <h4>Locks:</h4>
              <Widget size={1} items={lockRules} />
            </Card>
          )}
          <Row gutter={[32, 32]} className="dashboard-container-row">
            <Col
              className="dashboard-container-col"
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              {getRole === "HUBADMIN" && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="dashboard-container-col-innercol"
                    >
                      <div className="dashboard-container-col-innercol-trackOrder">
                        <span
                          style={{ color: "green", fontSize: "13px" }}
                          className="dashboard-container-col-innercol-trackOrder-name"
                        >
                          Shipment Status
                        </span>
                        <div style={{ color: "red", fontSize: "13px" }}>
                          Results as on
                          {day ? `${onClickTime} Today` : "Yesterday"}
                          {day ? (
                            <Tooltip title={"Reload"}>
                              <ReloadOutlined
                                onClick={() => getTodaysData()}
                                style={{
                                  fontSize: 18,
                                  paddingLeft: "10px",
                                  color: "black",
                                }}
                              />
                            </Tooltip>
                          ) : null}
                        </div>
                      </div>

                      <div className="custom-carousel">
                        <Carousel
                          {...settings}
                          infinite={false}
                          afterChange={handleAfterChange}
                          initialSlide={1}
                        >
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                        </Carousel>
                      </div>
                    </Col>
                  </Row>
                </Spin>
              )}
              <Row gutter={[32, 32]}>
                {role.includes(CP_ADMIN) &&
                currentEnv === "qa" &&
                !JSON.parse(localStorage.getItem("isEnableCP"))
                  ? ""
                  : dashboardMenuList?.map((item, index) => {
                      if (
                        item?.role === "" ||
                        item.role.some((e) =>
                          accountDetails?.roles?.includes(e)
                        )
                      ) {
                        return (
                          <Col
                            xl={4}
                            lg={8}
                            md={10}
                            sm={12}
                            xs={12}
                            className="cash-booking"
                            key={index}
                          >
                            <DashbordCard
                              accountBookingArrowIcon={accountBookingArrowIcon}
                              accountBookingIcon={item.icon}
                              watchIcon={calenderIcon}
                              bookingType={item.title}
                              route={item.route}
                              id="cashBooking"
                              stateId={item.stateId}
                              clearSessionStorage={item.clearSessionStorage}
                              isDownload={item.isDownload}
                              disabled={
                                item.disabled ||
                                (item?.lockType && isLocked?.is_locked)
                              }
                            />
                          </Col>
                        );
                      }
                    })}
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}

Dashboard.propTypes = {
  data1: PropTypes.number,
};

export default Dashboard;

const ShipmentStatusCompo = ({ array, styleObj }) => (
  <Row gutter={12} className="p-1">
    {array?.map((item, i) => (
      <Col lg={6} md={6} sm={6} key={i}>
        <div
          className="shipmentStatusContainer"
          style={styleObj[item?.status]?.styles}
        >
          <div className="textNumber" style={styleObj[item?.status]?.textColor}>
            {item?.total_count}
          </div>
          <div>{capitalize(item?.status)}</div>
        </div>
      </Col>
    ))}
  </Row>
);
